export interface ELSS_CALCULATOR_PROPS {
  investmentOption: string | undefined;
  principleAmount: number | undefined;
  annualrate: number | undefined;
  durationOfInvestment?: number | undefined;
  durationOfSip?: number | undefined;
  frequencyOfSip?: string | undefined;
}

export const ELSS_CALCULATOR_FORMULA = ({
  principleAmount,
  annualrate,
  durationOfInvestment,
  investmentOption,
  frequencyOfSip,
  durationOfSip,
}: ELSS_CALCULATOR_PROPS) => {
  if (
    !principleAmount ||
    principleAmount < 0 ||
    !annualrate ||
    annualrate < 0 ||
    !investmentOption ||
    (investmentOption === 'lumpsum_one_time' &&
      (!durationOfInvestment || durationOfInvestment < 0)) ||
    (investmentOption === 'sip' &&
      (!frequencyOfSip || !durationOfSip || durationOfSip < 0))
  ) {
    return { investmentAtMaturity: 0 };
  }

  let investmentAtMaturity = 0;
  if (investmentOption === 'lumpsum_one_time' && durationOfInvestment) {
    investmentAtMaturity =
      principleAmount * Math.pow(1 + annualrate / 100, durationOfInvestment);
  } else if (investmentOption === 'sip' && frequencyOfSip && durationOfSip) {
    let periodsPerYear;

    switch (frequencyOfSip.toLowerCase()) {
      case 'monthly':
        periodsPerYear = 12;
        break;
      case 'fortnightly':
        periodsPerYear = 26; // There are 26 fortnights in a year
        break;
      case 'quarterly':
        periodsPerYear = 4;
        break;
      default:
        periodsPerYear = 12; // Defaulting to monthly if not specified
    }

    const ci = annualrate / 100 / periodsPerYear; // Adjusting the compound interest rate per period
    const numberOfPayments = periodsPerYear * durationOfSip; // Total number of payments

    // Calculate the total value using the adjusted compound interest formula for SIP
    investmentAtMaturity =
      principleAmount *
      ((Math.pow(1 + ci, numberOfPayments) - 1) / ci) *
      (1 + ci);
  }
  return { investmentAtMaturity: Math.round(investmentAtMaturity) };
};
